export default __webpack_public_path__ + "static/media/11.b54f9cd5.jpg";